import { render, staticRenderFns } from "./houseBoard.vue?vue&type=template&id=4dfe6948&scoped=true&"
import script from "./houseBoard.vue?vue&type=script&lang=ts&"
export * from "./houseBoard.vue?vue&type=script&lang=ts&"
import style0 from "./houseBoard.vue?vue&type=style&index=0&id=4dfe6948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe6948",
  null
  
)

export default component.exports